import React from "react";
import { useForm, Controller } from "react-hook-form";
import Subheading from "@hui/_atoms/subheading/Subheading";
import Paragraph from "@hui/_atoms/paragraph/Paragraph";
import { Combobox } from "../../_molecules/combobox/Combobox";
import { postVerifyIdentityBasicDetails, verifyIdentityBasicDetailsDto } from "../../../API/onboarding/verify_identity_basic_details.api";
import handleError from "../../../API/utils/handleError";
import convertCamelToSnakeCase from "../../../utilities/case-conversions/snakeCase";
import { iVerifyIdentityBasicDetailsForm, verifyIdentityBasicDetailsForm } from "./types/onboardingTypes";
import I18n from "../../../utilities/translations";
import FormWrapper from "./Shared/FormWrapper";
import FormBody from "./Shared/FormBody";
import FormButton from "./Shared/FormButton";

const ctx = { scope: "onboarding.v3.verify_identity_basic_details" };

const VerifyIdentityBasicDetailsForm = ({stateUpdate, countryList} : iVerifyIdentityBasicDetailsForm) => {
  const { handleSubmit, formState: { errors, isValid } , control } = useForm<verifyIdentityBasicDetailsForm>({defaultValues: {countryOfBirth: null, nationality: null}});

  const onSubmit = async (body: verifyIdentityBasicDetailsForm) => {
    try {
      const formattedRequest = convertCamelToSnakeCase(body) as verifyIdentityBasicDetailsDto
      const res = await postVerifyIdentityBasicDetails(formattedRequest)
      if (res.status === "ok") {
        stateUpdate(res.data.state)}
      else {
        handleError(res)
      }
    } catch (err) {
      toastr.error("Something went wrong, please try again");
      throw err
    }
  }

  return (<>
    <FormWrapper>
      <form onSubmit={handleSubmit(onSubmit)} className="tw-flex tw-flex-col tw-flex-1 tw-overflow-hidden">
        <FormBody>
          <Subheading>{I18n.t("heading", ctx)}</Subheading>
          <Paragraph>{I18n.t("description", ctx)}</Paragraph>
          <div className="align-items-center justify-content-center tw-mb-6">
            <Controller
              control={control}
              name="countryOfBirth"
              rules={{ required: I18n.t("required.country_of_birth", ctx), }}
              render={({ field: { onChange, value } }) => (
                <Combobox name={"countryOfBirth"} entries={countryList} selectedValue={value} setSelectedValue={onChange} legacyStyles={false}
                  label={ I18n.t("labels.country_of_birth", ctx) } id={"countryOfBirthCombobox"} openMenuOnFocus={true} placeholder={"Start typing to search"} requiredIconOnly={true}/>
              )} />
            {errors?.countryOfBirth && (
              <span className="tw-text-sm tw-text-red-600">
                {errors.countryOfBirth.message}
              </span>
            )}
          </div>
          <div className="align-items-center justify-content-center">
            <Controller
              control={control}
              name="nationality"
              rules={{ required: I18n.t("required.nationality", ctx), }}
              render={({ field: { onChange, value } }) => (
                <Combobox name={"nationality"} entries={countryList} selectedValue={value} setSelectedValue={onChange} legacyStyles={false}
                  label={ I18n.t("labels.nationality", ctx) } id={"nationalityCombobox"} openMenuOnFocus={true} placeholder={"Start typing to search"} requiredIconOnly={true}/>
              )} />
            {errors?.nationality && (
              <span className="tw-text-sm tw-text-red-600">
                {errors.nationality.message}
              </span>
            )}
          </div>
        </FormBody>
        <FormButton>
          <div className="md:tw-pb-4">
            <input type="submit" title="next" value="Next" className="hnry-button hnry-button--primary tw-w-full" disabled={!isValid}/>
          </div>
        </FormButton>
      </form>
    </FormWrapper>
  </>

  )
}
export default VerifyIdentityBasicDetailsForm